//setting auth params
export const setAuthParams = (params, value, category_id) => {
  let updateParams = params ? { ...params } : value;
  updateParams.category_id = parseInt(value?.category_id);
  updateParams.category_name = value?.category_name;

  return (dispatch) => {
    dispatch({ type: "SET_AUTH_PARAMS", payload: updateParams });
  };
};

//setting global brands
export const setGlobalBrands = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_GLOBAL_BRANDS", payload: value });
  };
};

//setting global brands for dashboards
export const setGlobalCategory_id = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_GLOBAL_CATEGORY_ID", payload: value });
  };
};
